import {ErrorMessage} from 'angular-error-repository';

export const selectItemError: ErrorMessage = () => {
    return 'Please select an item from the dropdown';
};
